import { Button, Grid, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { validateInput } from 'src/utils/common';

const Search: React.FC<{
  setFilteredDomains: (domains: Domain[]) => void;
  updateSearchQuery: (searchQuery: string) => void;
  selectDomain: (domain: Domain) => void;
  register: () => void;
  domains: Domain[];
  searchQuery: string;
}> = ({
  setFilteredDomains,
  updateSearchQuery,
  selectDomain,
  register,
  domains,
  searchQuery,
}) => {
  useEffect(() => {
    setFilteredDomains(
      domains.length > 0
        ? domains.filter(domain =>
            domain.name.toLowerCase().startsWith(searchQuery.toLowerCase()),
          )
        : domains,
    );
  }, [searchQuery]);

  const findMatchingDomain = (value: string): Domain | undefined => {
    return domains.find(domain => domain.name.split('.')[0] === value);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={8}>
        <TextField
          value={searchQuery}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            if (validateInput(event.target.value)) {
              updateSearchQuery(event.target.value);
            }
          }}
          onKeyDown={e => {
            if (e.key === 'Tab') {
              const matchingSuggestion = domains.find(suggestion =>
                suggestion.name.startsWith(searchQuery),
              );
              if (matchingSuggestion) {
                e.preventDefault();
                updateSearchQuery(matchingSuggestion.name.split('.')[0]);
              }
            }
          }}
          fullWidth
          placeholder="Search domain"
          sx={{
            '& .MuiOutlinedInput-root': {
              height: '46px',
              '&:hover fieldset': {
                borderColor: 'grey.600',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'grey.600',
              },
            },
          }}
        />
      </Grid>
      <Grid item xs={4}>
        {domains.length > 0 && findMatchingDomain(searchQuery) ? (
          <Button
            variant="contained"
            fullWidth
            sx={{
              color: 'text.primary',
              backgroundColor: 'primary.main',
              padding: '10px 16px',
            }}
            onClick={() => {
              if (searchQuery.length != 0) {
                selectDomain(domains[0]);
              }
            }}
          >
            Open Domain
          </Button>
        ) : (
          <Button
            variant="contained"
            fullWidth
            sx={{
              color: 'text.primary',
              backgroundColor: 'primary.main',
              padding: '10px 16px',
            }}
            onClick={register}
            disabled={searchQuery.length <= 3}
          >
            Register Domain
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default React.memo(Search);
